import { matchesNew } from '@components/bid_request/details/utils/matchesNew';
import type { LotChanges } from 'types';

export const countDeletedSavedRows = (lotChanges?: LotChanges): number => (
  Object.entries(lotChanges?.line_items ?? {}).filter(([id, row]) => !matchesNew(id) && row?._destroy).length
);
